<template>

    <div class="view-configurator">

        <div :id="`canvas-${productConfigurationView.id}-container`">
            <canvas :id="`canvas-${productConfigurationView.id}`"></canvas>
        </div>

        <div :id="`canvas-to-png-${productConfigurationView.id}-container`" style="display: none!important;">
            <canvas :id="`canvas-to-png-${productConfigurationView.id}`"></canvas>
        </div>

        <input type="range" :min="boundingBoxState.getMinY()" :max="boundingBoxState.getMaxY()" :value="boundingBoxState.getTop()" @input="boundingTop">

        Min: {{boundingBoxState.getMinY()}}
        Max: {{boundingBoxState.getMaxY()}}
        Current: {{boundingBoxState.getTop()}}

        <input type="range" :min="boundingBoxState.getMinX()" :max="boundingBoxState.getMaxX()" :value="boundingBoxState.getLeft()" @input="boundingLeft">

        Min: {{boundingBoxState.getMinX()}}
        Max: {{boundingBoxState.getMaxX()}}
        Current: {{boundingBoxState.getLeft()}}

        <div id="zoom" @click="resetZoom" title="Click to reset">{{ currentZoom }}% <i class="material-icons">zoom_in</i></div>

    </div>
</template>

<script>
    import CanvasView from "./CanvasView";
    import BoundingBox from "./../structures/canvas-objects/AdminBoundingBox";

    export default {
        name: "AdminCanvasView",
        extends: CanvasView,
        props: {
            /**
             * @type AdminBoundingBox
             */
            boundingBoxState: {
                type: Object,
                default: () => ({})
            }
        },
        methods: {
            boundingTop(e) {

                this.boundingBoxState.setTop(parseInt(e.target.value), true);
                this.boundingBoxState.getCanvas().render();

            },
            boundingLeft(e) {

                this.boundingBoxState.setLeft(parseInt(e.target.value), true);
                this.boundingBoxState.getCanvas().render();

            },
            initWhenMounted() {

                /**
                 * @type Canvas
                 */
                const canvas = this.productConfigurationView.canvas;

                /**
                 * @type BoundingBox
                 */
                const boundingBox = new BoundingBox(
                    canvas,
                    this.productConfigurationView.boundingBox.x.min,
                    this.productConfigurationView.boundingBox.x.max,
                    this.productConfigurationView.boundingBox.y.min,
                    this.productConfigurationView.boundingBox.y.max
                );

                boundingBox.set({
                    width: this.productConfigurationView.boundingBox.sizes.width,
                    height: this.productConfigurationView.boundingBox.sizes.height,
                    left: this.productConfigurationView.boundingBox.x.current,
                    top: this.productConfigurationView.boundingBox.y.current
                });

                canvas.createCanvas(
                    `canvas-${this.productConfigurationView.id}`,
                    this.productConfigurationView.canvasWidth,
                    this.productConfigurationView.canvasHeight,
                    boundingBox,
                    this.canvasObjectsOnProductConfigurationView
                );

                if (window['w2p_admin']) {
                    canvas._boundingBox = null;
                }

                if (! window.canvas )
                    window.canvas = [];

                window.canvas[`canvas-${this.productConfigurationView.id}`] = canvas;

                canvas.initEventHandler();

                canvas.render();

            }
        }
    }
</script>